// Generated with util/create-component.js
import React, { useState, useMemo, PropsWithChildren } from "react";

import { ButtonGroupProps, ButtonProps } from "./Button.types";

import { StyledButtonGroup } from "./Button.styles";

import Button from "./Button";
import { State } from "../../shared.types";

const ButtonGroup: React.FC<PropsWithChildren<ButtonGroupProps>> = ({
  theme,
  "gs-style": style = "solid",
  width = "auto",
  divider = "none",
  toggle = false,
  children,
  ...nativeProps
}) => {
  const buttons = React.Children.toArray(children);
  const [active, setActive] = useState<string>(null);

  const handleButtonClick = (e, button, onClick?: (...args) => any) => {
    const state = getButtonState(button);

    switch (true) {
      case toggle && state === "active":
        setActive(null);
        break;
      case toggle && state === "default":
        setActive(button.key);
        break;
    }

    onClick && onClick(e);
  };

  const getButtonState = (button): State => {
    switch (true) {
      case button.key === active:
        return "active";
      case !!button.props?.state:
        return button.props.state;
      default:
        return "default";
    }
  };

  return (
    <StyledButtonGroup
      className={`buttonGroup width-${width} divider-${divider}`}
    >
      {React.Children.map(buttons, (button) => {
        if (!React.isValidElement<ButtonProps>(button)) {
          return button;
        }

        const {
          label,
          style: ignoreStyle,
          theme: buttonTheme,
          arrow,
          ...buttonProps
        } = button.props;

        return (
          <Button
            label={label}
            state={getButtonState(button)}
            gs-style={style}
            theme={theme || buttonTheme}
            width="auto"
            arrow={arrow}
            onClick={(e) => {
              handleButtonClick(e, button, button.props.onClick);
            }}
            {...nativeProps}
            {...buttonProps}
          >
            {button.props.children}
          </Button>
        );
      })}
    </StyledButtonGroup>
  );
};

export default ButtonGroup;
